































import { Component, Prop, Vue } from 'vue-property-decorator';
import { LeuteUndGeldViewModel } from '@/services/api/nswag/stapiclient_generated';

import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  components: { StBadge, StTabs, AccountSettingsInvoice },
})
export default class LeuteUndGeldTable extends Vue {
  @Prop() leute: LeuteUndGeldViewModel;
}
